import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";
import { supabase } from "@/integrations/supabase/client";
import App from './App.tsx';
import './index.css';


Sentry.init({
  dsn: "https://9da717816cfccf027ba42c015f1e8959@o4508745201942528.ingest.us.sentry.io/4508745249587200",
  integrations: [
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: "system",
    }),
  ]
});

createRoot(document.getElementById("root")!).render(<App />);